import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/900.css'

import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import * as React from 'react'
import { marketingTheme } from '../theme'

type MarketingThemeProviderProps = {
  children: React.ReactNode
}

const MarketingThemeProvider = ({ children }: MarketingThemeProviderProps) => (
  <ThemeProvider theme={marketingTheme}>
    <CssBaseline />
    {children}
  </ThemeProvider>
)

export default MarketingThemeProvider
